var c3 = require('c3');
export default function ($stateProvider) {
    /*
        TODO: Enable filtering by:
        - Activity
        - Cognitive Function
        - GDS
        - Category
    */
    $stateProvider.state('exercises_distribution', {
        parent: 'ng-admin',
        url: '/stats/exercises_distribution',
        params: { },
        controller: [
            'endpoint',
            '$auth',
            '$window',
            function(endpoint, $auth, $window) {
                var centerId = $window.localStorage.getItem('center_id');
                var chart = c3.generate({
                    bindto: '#chart',
                    data: {
                      mimeType: 'csv',
                      url: endpoint + '/centers/' + centerId + '/dashboard/exercises_per_cf_and_gds',
                      headers: $auth.retrieveData('auth_headers'),
                    //   columns: [
                    //       ['cognitive_function', 'Atención', 'Lenguaje', 'Cálculo', 'Praxias'],
                    //       [1, 30, 200, 100, 400],
                    //       ['2', 90, 100, 140, 200]
                    //   ],
                      x: 'cognitive_function',
                      groups: [
                          ['1', '2', '3', '4', '5', '6', '7']
                      ],
                      type: 'bar'
                    },
                    axis: {
                        x: {
                            type: 'category'
                        }
                    },
                    legend: {
                        // hide: true
                    }
                });
            }
        ],
        template: "<h1>{{ \"\" | translate }}</h1><div id='chart'></div>"
    });
};



// WEBPACK FOOTER //
// ./js/stats/exercisesDistribution.js